<typography-v2 *ngIf="props.calculatedValue | async as value; else empty" look="text">{{
  Number(value) | rdrCurrency: format
}}</typography-v2>
<ng-template #empty>
  <typography-v2 look="text">{{ 0 | rdrCurrency }}</typography-v2>
</ng-template>
